import { Card } from "react-bootstrap";

// One of the three stacked feature cards on the home page.
// Layout is image + content side-by-side (stacked on mobile).
// Set imageRight to flip the sides (for the middle card).
export const HomeCard = ({ image, title, text, linkTo, linkLabel, imageRight = false }) => {
  const mediaImage = (
    <div className="home-card-img-rect" style={{ backgroundImage: `url(${image})` }} />
  );

  const body = (
    <Card.Body
      className={
        imageRight
          ? "d-flex flex-column justify-content-center align-items-end text-end order-2 order-md-1"
          : "d-flex flex-column justify-content-center align-items-start"
      }
    >
      <Card.Title className="fw-bold home-card-title">{title}</Card.Title>
      <Card.Text className="home-card-text">{text}</Card.Text>
      <a href={linkTo} className="btn-cta">
        {linkLabel}
      </a>
    </Card.Body>
  );

  return (
    <Card className="home-card flex-md-row flex-column align-items-center shadow-sm">
      {imageRight ? (
        <>
          {body}
          <div className="home-card-media order-1 order-md-2 align-self-stretch">{mediaImage}</div>
        </>
      ) : (
        <>
          {mediaImage}
          {body}
        </>
      )}
    </Card>
  );
};
